'use client';

import { Suspense } from 'react';
import { AccountMenu } from '@/app_components/common/header/AccountMenu';
import { SignInButton } from '@/app_components/common/header/SignInButton';
import { SubscribeButton } from '@/app_components/common/header/SubscribeButton';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { useUser } from '@/app_lib/providers/UserProvider';
import { cn } from '@/app_lib/utils/utils';

interface AuthMenuProps {
  loggedIn: boolean;
  hasAccess: boolean;
}

export const AuthMenu = ({ loggedIn, hasAccess }: AuthMenuProps) => {
  const { pianoLoadingState } = useUser();
  const loading = pianoLoadingState !== 'loaded';

  const content = (
    <div className='flex gap-2 md:gap-6'>
      {/* Show subscribed button if not logged in or they don't have a subscription */}
      {!(loggedIn && hasAccess) && (
        <div
          className={cn(
            loggedIn && 'hidden md:inline-block',
            loading && 'bg-helper animate-pulse rounded-full cursor-not-allowed',
          )}
        >
          {/* NOTE: we need a suspense since the subscribe button is using useSearchParams, this is not the same as the loading state */}
          <Suspense
            fallback={
              <ButtonV2
                as='button'
                className='bg-helper animate-pulse'
              >
                Subscribe Now
              </ButtonV2>
            }
          >
            <span className={cn(loading && 'invisible pointer-events-none')}>
              <SubscribeButton>
                <span className='md:hidden'>Subscribe</span>
                <span className='hidden md:inline'>Subscribe Now</span>
              </SubscribeButton>
            </span>
          </Suspense>
        </div>
      )}
      {loggedIn ? (
        <AccountMenu disabled={loading} />
      ) : (
        <SignInButton
          className='hidden md:inline-block'
          disabled={loading}
        />
      )}
    </div>
  );

  return <span>{content}</span>;
};
